/**
 * Created by Boris on 16/05/2018.
 */
import {AddressDetails} from './address-details';

export class PostalAddress extends AddressDetails {
  addressType: string;
  poBox: string;
  recycledWaterZone: string;

  toUpperCase() {
    super.toUpperCase();

    if (this.poBox) {
      this.poBox = this.poBox.toUpperCase();
    }
  }

  copy(address: PostalAddress) {
    super.copy(address);
    this.poBox = address.poBox;
  }

  copyAddressDetail(address: AddressDetails) {
    super.copy(address);
  }

  clear() {
    super.clear();
    this.poBox = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-objects/postal-address.ts